import { actionCreator } from '@ardoq/rxbeach';
import { ViewIds } from '@ardoq/api-types';
import type { HasViewpointMode } from '@ardoq/graph';

export type PayloadActiveTab = {
  readonly activeTabId: ViewIds;
};
export type PayloadActiveMainTabLeft = PayloadActiveTab & HasViewpointMode;

export const setActiveMainTabLeft = actionCreator<PayloadActiveMainTabLeft>(
  '[mainContent] SET_ACTIVE_MAIN_TAB_LEFT'
);
export const setActiveMainTabRight = actionCreator<PayloadActiveTab>(
  '[mainContent] SET_ACTIVE_MAIN_TAB_RIGHT'
);

export const renderMainContentView = actionCreator(
  '[mainContent] RENDER_MAIN_CONTENT_VIEW'
);

export type AllWorkspacesClosedPayload = {
  keepCurrentViewPointMode?: boolean;
};

export const allWorkspacesClosed = actionCreator<AllWorkspacesClosedPayload>(
  '[mainContent] ALL_WORKSPACES_CLOSED'
);
